import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    estatusEvaluacion: [],
  },

  getters: {
    getEstatusEvaluacion: (state) => state.estatusEvaluacion,
  },

  mutations: {
    SET_ESTATUS_EVALUACION(state, estatusEvaluacion) {
      state.estatusEvaluacion = estatusEvaluacion;
    },
  },

  actions: {
    async fetchEstatusEvaluacion({ commit }) {
      await axios
        .get('/PoliciaCuadrantes/C3/catEstatusEvaluacion')
        .then((response) => {
          commit('SET_ESTATUS_EVALUACION', response.data.data);
        });
    },
  },
};
